import { useGetHighProteinMeals } from "@/hooks/requests/meal/use-get-high-protein-meals";
import { memo } from "react";
import { HomeFeedMealsList } from "../home-feed-meals-list";

export const OurProteinFavouritesPlanList = memo(function OurProteinFavouritesPlanList() {
  const { highProteinMeals, isLoading } = useGetHighProteinMeals();

  return (
    <HomeFeedMealsList
      title="Our Protein Favourites"
      meals={highProteinMeals}
      isLoading={isLoading}
      emptyStateText="No high-protein meals available right now."
    />
  );
});
